import { loadStripe } from "@stripe/stripe-js";
import axios from "axios";
import { API } from "../App";

let stripePromise = null;

export function getStripe(token) {
  if (stripePromise) return stripePromise;
  stripePromise = axios
    .get(`${API}/config/stripe-publishable-key`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((res) => loadStripe(res.data.publishable_key))
    .catch((err) => {
      stripePromise = null;
      throw err;
    });
  return stripePromise;
}
